import React from "react";
import { SparklesIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/content";
export function Hero() {
  return <header className="bg-cream px-4 pb-14 pt-6 md:pb-20 md:pt-10" data-id="element-166" data-mp="cut9pwmq7l4c">
      <div className="mx-auto max-w-4xl text-center" data-id="element-167" data-mp="huo264m5giri">
        <div className="flex flex-wrap items-center justify-center gap-2.5" data-id="element-168" data-mp="hwikrc9y7ysf">
          <div className="flex items-center gap-2" data-id="element-169" data-mp="mszdykw093cd">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-berry text-white" data-id="element-170" data-mp="qvm7cq8bqwbo">
              <SparklesIcon className="h-5 w-5" aria-hidden="true" data-id="element-171" data-mp="vmcfgb84xda2" />
            </span>
            <span className="font-serif text-[19px] font-bold text-ink" data-id="element-172" data-mp="vootweeop5id">Nail Course In A Box™</span>
          </div>
          <span className="rounded-full border border-petal bg-white px-3 py-1 text-[12px] font-semibold uppercase tracking-wide text-berry" data-id="element-173" data-mp="15ks3u6fs28fv">
            For nail educators
          </span>
        </div>

        <h1 className="mt-7 font-serif text-[36px] font-bold leading-[1.08] tracking-tight text-ink sm:text-5xl md:text-[64px]" data-id="element-174" data-mp="9njb4dqh2id9">
          Build a Professional Nail Class in <em className="text-berry" data-id="element-175" data-mp="4qst3kv3xcp7">under 60 minutes</em>
        </h1>
        <p className="mt-3 font-serif text-[21px] italic text-ink/80 md:text-2xl" data-id="element-176" data-mp="3vvsm34zn2jjm">— without starting from scratch.</p>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted md:text-lg" data-id="element-177" data-mp="3rv8mlurlf3ub">
          A complete step-by-step system that helps nail educators turn their knowledge into polished, professional
          classes their students can actually follow. Includes <strong className="text-ink" data-id="element-178" data-mp="infr7qysq8wp">6 premium volumes</strong>,{" "}
          <strong className="text-ink" data-id="element-179" data-mp="en5k2az9pcg9">5 professional bonus kits</strong>, editable Canva templates, class structures,
          student worksheets, assessments, checklists and certificates.
        </p>

        <img src={images.mockup} alt="Nail Course In A Box™ — 6 premium volumes, worksheets, checklists and certificates on laptop, tablet and phone" className="mx-auto mt-8 w-full max-w-3xl" data-id="element-180" data-mp="16ebp95tui0ce" />

        <CTAButton id="first-cta" label="Create my first nail class" note="Instant Access · One-Time Payment of $27 · Lifetime Access · 7-Day Guarantee" data-id="element-181" data-mp="35jp5x53nxz1f" />
        <Countdown data-id="element-182" data-mp="2vu5n1zfya56k" />
      </div>
    </header>;
}